import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ContactForm from '../../shared/contact-form';
import { SectionTitle } from './styles';

const Container = styled.div`
  position: relative;
  margin-top: 180px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(SectionTitle)`
  font-size: 32px;
  line-height: 42px;
  margin-bottom: 10px;
`;

const FormContainer = styled.div`
  width: 100%;
  max-width: 530px;
  padding: 0 20px;

  textarea::placeholder,
  input::placeholder {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightBold};
  }

  button {
    width: 100%;
    margin-top: 20px;
  }
`;

export default function Contact(props) {
  const { formId, formName, formTitle } = props;

  return (
    <Container id={formId} name={formName}>
      <Title>{formTitle}</Title>
      <FormContainer>
        <ContactForm />
      </FormContainer>
    </Container>
  );
}

Contact.propTypes = {
  formId: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
};
